import { render, staticRenderFns } from "./WeekStatisticsTip.vue?vue&type=template&id=63b9f7ed&scoped=true"
import script from "./WeekStatisticsTip.vue?vue&type=script&lang=js"
export * from "./WeekStatisticsTip.vue?vue&type=script&lang=js"
import style0 from "./WeekStatisticsTip.vue?vue&type=style&index=0&id=63b9f7ed&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9f7ed",
  null
  
)

export default component.exports